<div class="navigation-grid-component">
    <div class="grid-container">
        <div class="grid-row" *ngFor="let row of rows; let i = index"
            [hidden]="(i === 0 && !showNavigation) || (i === 1 && !showEdit)">
            <span class="material-symbols-outlined" [title]="i === 0 ? 'Navigate' : 'Edit'">
                {{ i === 0 ? 'double_arrow' : 'edit' }}
            </span>
            <div class="grid-item">
                <ng-container *ngFor="let item of row.items; let last = last">
                    <span class="item-label-container" [style.max-width]="itemMaxWidth">
                        <span class="item-label" [class.disabled]="item.disabled" [title]="item.label"
                            (click)="item.disabled ? null : navigate(item.navPath)">
                            {{ item.label }}
                        </span>
                    </span>{{ last ? '' : ' > ' }}
                </ng-container>
            </div>
        </div>
    </div>
</div>